import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
} from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { addUserRoles } from "src/app/core/models/user";
import {
  UserDetails,
  UserRoleNames,
  UserRolesInt,
  Users,
} from "src/app/core/models/users";
import { AuthenticationService } from "src/app/core/services/authentication.service";
import { UserService } from "src/app/core/services/user.service";
import { FileTypes } from "../../../../core/models/application";
import { HttpEventType } from "@angular/common/http";

@Component({
  selector: "app-update-user",
  templateUrl: "./update-user.component.html",
  styleUrls: ["./update-user.component.scss"],
})
export class UpdateUserComponent implements OnInit {
  editUserForm: UntypedFormGroup;
  idx: number;
  currentUserRole = this.authenticationService.getRole();
  loggedInUser: string = this.authenticationService.currentUserValue.username;
  userInfoesData: UserDetails[];
  userDetails: Users;
  role: number;
  file: File;
  isGlobalAdmin: boolean = this.currentUserRole == UserRoleNames.GlobalAdmin;
  allowChangeUserRole: boolean = false;
  roleToChange: string;

  // File upload status tracking
  uploadProgress = 0;
  isUploading = false;
  uploadStatus:
    | "none"
    | "uploading"
    | "success"
    | "error"
    | "exists"
    | "unauthorized" = "none";
  uploadMessage = "";

  userInBatch: boolean = false;
  weekDayList: any = [
    { day: "Monday", value: 0 },
    { day: "Tuesday", value: 1 },
    { day: "Wednesday", value: 2 },
    { day: "Thursday", value: 3 },
    { day: "Friday", value: 4 },
    { day: "Saturday", value: 5 },
    { day: "Sunday", value: 6 },
  ];
  constructor(
    public dialog: MatDialogRef<UpdateUserComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      userName: string;
      emailId: string;
      contactNo: string;
      userRole: string;
      firstName: string;
      lastName: string;
      allocatedCoreQuota?: number;
      publicKey: string;
      userStartCommand: string;
      perSessionMaxTime: number;
      weeekDaySequence: string;
      batchStartDate: string;
      batchEndDate: string;
      batchStartTime: string;
      batchEndTime: string;
      userInBatch: boolean;
      sessionWalletBalance: number;
      additionalInfo: string;
      anywareGuid: string;
      anywareUpn: string;
    },
    private userService: UserService,
    private authenticationService: AuthenticationService,
    private snackBar: MatSnackBar
  ) {}

  fileTypes: FileTypes[] = [
    { name: "RDP File", value: "6" },
    { name: "VNC File", value: "7" },
  ];

  types: addUserRoles[] = [
    { name: UserRoleNames.GlobalAdmin, value: UserRolesInt.GlobalAdmin },
    {
      name: UserRoleNames.DeploymentAdmin,
      value: UserRolesInt.DeploymentAdmin,
    },
    // { name: UserRoleNames.PowerUser, value: UserRolesInt.PowerUser },
    { name: UserRoleNames.JobOperator, value: UserRolesInt.JobOperator },
  ];

  @ViewChild("chooseAppFile") chooseAppFile;

  ngOnInit() {
    let weekDaysNumbers = null;
    this.userInBatch = this.data.userInBatch;
    if (this.data.weeekDaySequence) {
      weekDaysNumbers = this.data.weeekDaySequence
        .split(",")
        .map((el) => Number(el));
    }
    this.userService.getUserRole(this.loggedInUser).subscribe((data) => {
      this.role = Number(data);
    });
    this.allowChangeUserRole =
      this.data.userRole == "0" || this.data.userRole == "4" ? true : false;
    if (this.data.userRole == "0" || this.data.userRole == "4") {
      if (this.data.userRole == "4") {
        this.roleToChange = "Global Admin";
      } else {
        this.roleToChange = "Reader";
      }
    }
    this.editUserForm = new UntypedFormGroup({
      editUserEmail: new UntypedFormControl(this.data.emailId, [
        Validators.required,
        Validators.pattern(/^([\w+-.%]+@[\w-.]+\.[A-Za-z]{2,4},?)+$/),
      ]),
      editUserContact: new UntypedFormControl(this.data.contactNo, [
        Validators.pattern(
          "^[+]?[(]?[0-9]{3}[)]?[-s.]?[0-9]{3}[-s.]?[0-9]{4,6}$"
        ),
      ]),
      editFirstName: new UntypedFormControl(this.data.firstName),
      editUserName: new UntypedFormControl(
        {
          value: this.data.userName,
          disabled: !this.authenticationService.isLoggedInUserEqualToRequestor(
            this.data.userName
          ),
        },
        [
          Validators.required,
          Validators.pattern("^[a-zA-Z0-9-_@][a-zA-Z0-9-_.@]{1,35}"),
        ]
      ),
      editLastName: new UntypedFormControl(this.data.lastName),
      editAllocatedCoreQuota: new UntypedFormControl(
        this.data.allocatedCoreQuota,
        [Validators.pattern("^[1-9]{1,5}|^-[1]{1}$")]
      ),
      editPublicKey: new UntypedFormControl(this.data.publicKey),
      editUserCommand: new UntypedFormControl(this.data.userStartCommand),
      fileTypeApp: new UntypedFormControl(null),
      rdp_File: new UntypedFormControl(null),
      vnc_File: new UntypedFormControl(null),
      perSessionMaxTime: new UntypedFormControl(this.data.perSessionMaxTime),
      userRoleChangeReaderGlobalAdmin: new UntypedFormControl("false"),
      sessionBalance: new UntypedFormControl(this.data.sessionWalletBalance),
      batchStartDate: new UntypedFormControl(
        this.data.batchStartDate ? new Date(this.data.batchStartDate) : null
      ),
      batchEndDate: new UntypedFormControl(
        this.data.batchEndDate ? new Date(this.data.batchEndDate) : null
      ),
      batchStartTime: new UntypedFormControl(this.data.batchStartTime),
      batchEndTime: new UntypedFormControl(this.data.batchEndTime),
      weekSequence: new UntypedFormControl(weekDaysNumbers),
      editUserAdditionalInfo: new UntypedFormControl(this.data.additionalInfo),
      editAnywareUserGuid: new UntypedFormControl(this.data.anywareGuid),
      editAnywareUserUpn: new UntypedFormControl(this.data.anywareUpn),
    });
    if (this.currentUserRole != UserRoleNames.GlobalAdmin) {
      this.editUserForm.get("editAllocatedCoreQuota").disable();
      this.editUserForm.get("editUserEmail").disable();
    }
  }

  showError(form) {
    this.editUserForm.markAllAsTouched();
  }

  onClose() {
    this.dialog.close({ data: false });
  }

  uploadFiles(event, id) {
    if (!this.editUserForm.value.fileTypeApp) {
      this.snackBar.open(`Please Select File Type To Upload.`, "OK", {
        duration: 5000,
      });
      return;
    }

    let selectedFileType = this.editUserForm.value.fileTypeApp.value;
    this.file = event.target.files[0];

    if (!this.file) {
      return;
    }

    // Reset upload status when new file is selected
    this.uploadStatus = "none";
    this.uploadMessage = "";
    this.uploadProgress = 0;

    // Check for multiple dots in filename
    let fileName = this.file.name;
    let dotCount = (fileName.match(/\./g) || []).length;

    if (dotCount > 1) {
      this.snackBar.open(
        `Please avoid using multiple dots in filename. Current file: "${fileName}". Rename to something like "${fileName
          .replace(/\./g, "_")
          .replace(/_([^_]+)$/, ".$1")}"`,
        "OK",
        { duration: 8000 }
      );
      this.uploadStatus = "error";
      this.uploadMessage = `File "${fileName}" contains multiple dots. Please rename the file to avoid issues.`;
      return;
    }

    if (this.file.type.length === 0) {
      let fileNameParts = this.file.name.split(".");
      let fileType = fileNameParts[fileNameParts.length - 1]; // Get the last part (actual extension)
      if (fileType.toLowerCase() != "rdp" && fileType.toLowerCase() != "vnc") {
        this.snackBar.open(
          `Please Upload ${selectedFileType == "6" ? "RDP" : "VNC"} File Type.`,
          "OK",
          { duration: 5000 }
        );
        return;
      }
    } else {
      if (this.file.type.toLowerCase() != selectedFileType.toLowerCase()) {
        this.snackBar.open(
          `Please Upload ${selectedFileType == "6" ? "RDP" : "VNC"} File Type.`,
          "OK",
          { duration: 5000 }
        );
        return;
      }
    }

    // Start upload immediately after file selection
    this.startFileUpload();
  }

  startFileUpload() {
    if (!this.file || !this.editUserForm.value.fileTypeApp) {
      this.snackBar.open("Please ensure file type is selected.", "OK", {
        duration: 5000,
      });
      return;
    }

    this.isUploading = true;
    this.uploadStatus = "uploading";
    this.uploadProgress = 0;
    this.uploadMessage = "Uploading file...";

    let selectedFileType = this.editUserForm.value.fileTypeApp.value;
    let fileTypeName = selectedFileType == "6" ? "rdp" : "vnc";

    this.userService
      .addUserRdpTemplate(this.data.userName, this.file, fileTypeName)
      .subscribe({
        next: (event) => {
          if (event.type === HttpEventType.UploadProgress) {
            this.uploadProgress = Math.round(
              (100 * event.loaded) / event.total
            );
          } else if (event.type === HttpEventType.Response) {
            this.uploadStatus = "success";
            this.uploadMessage = "File uploaded successfully!";
            this.isUploading = false;

            // Update form control with file name
            switch (selectedFileType) {
              case "6":
                this.editUserForm.controls["rdp_File"].setValue(this.file.name);
                break;
              case "7":
                this.editUserForm.controls["vnc_File"].setValue(this.file.name);
                break;
            }

            this.snackBar.open("File uploaded successfully!", "OK", {
              duration: 3000,
            });
          }
        },
        error: (error) => {
          this.isUploading = false;
          this.uploadProgress = 0;

          if (error.status === 404) {
            this.uploadStatus = "exists";
            this.uploadMessage = `File "${this.file.name}" already exists! Please rename or choose a different file.`;
          } else if (error.status === 401) {
            this.uploadStatus = "unauthorized";
            this.uploadMessage = "Not authorized to upload file!";
          } else if (error.status === 409) {
            this.uploadStatus = "error";
            this.uploadMessage = "User not found or upload conflict!";
          } else {
            this.uploadStatus = "error";
            this.uploadMessage = "Upload failed. Please try again.";
          }

          this.snackBar.open(this.uploadMessage, "OK", { duration: 7000 });
        },
      });
  }

  assignBatch(event) {
    if (event) {
      this.userInBatch = true;
      this.editUserForm.controls["batchStartDate"].setValidators([
        Validators.required,
      ]);
      this.editUserForm.controls["batchEndDate"].setValidators([
        Validators.required,
      ]);
      this.editUserForm.controls["batchStartTime"].setValidators([
        Validators.required,
      ]);
      this.editUserForm.controls["batchEndTime"].setValidators([
        Validators.required,
      ]);
      this.editUserForm.controls["weekSequence"].setValidators([
        Validators.required,
      ]);
    } else {
      this.userInBatch = false;
      this.editUserForm.controls["batchStartDate"].clearValidators();
      this.editUserForm.controls["batchEndDate"].clearValidators();
      this.editUserForm.controls["batchStartTime"].clearValidators();
      this.editUserForm.controls["batchEndTime"].clearValidators();
      this.editUserForm.controls["weekSequence"].clearValidators();
    }
    this.editUserForm.controls["batchStartDate"].updateValueAndValidity();
    this.editUserForm.controls["batchEndDate"].updateValueAndValidity();
    this.editUserForm.controls["batchStartTime"].updateValueAndValidity();
    this.editUserForm.controls["batchEndTime"].updateValueAndValidity();
    this.editUserForm.controls["weekSequence"].updateValueAndValidity();
  }

  onSubmit() {
    const form = this.editUserForm;
    let sequence = [0, 0, 0, 0, 0, 0, 0];
    let sequenceString = "";
    if (this.userInBatch) {
      if (form.value.weekSequence && form.value.weekSequence.length > 0) {
        form.value.weekSequence.forEach((el) => {
          sequence[el] = 1;
        });
        sequenceString = sequence.join("");
      }
    }

    let allocatedCoreQuotaValue;
    if (form.status == "INVALID") {
      this.showError(form);
    } else {
      let changeUserRole;
      if (this.allowChangeUserRole || this.allowChangeUserRole == true) {
        if (form.value?.userRoleChangeReaderGlobalAdmin === "true") {
          if (this.data.userRole == "4") {
            changeUserRole = 0;
          } else {
            changeUserRole = 4;
          }
        } else {
          changeUserRole = this.data.userRole;
        }
      } else {
        changeUserRole = this.data.userRole;
      }
      if (UserRoleNames.GlobalAdmin != this.currentUserRole) {
        allocatedCoreQuotaValue = this.data.allocatedCoreQuota;
      } else {
        allocatedCoreQuotaValue = form.value.editAllocatedCoreQuota;
      }
      let contactNumber = form.value.editUserContact;
      if (contactNumber == null || contactNumber == "") {
        contactNumber = "";
      }
      let userInfo = {
        adminId: this.authenticationService.currentUserValue.username,
        userName: this.data.userName,
        emailId: this.editUserForm.get("editUserEmail").value,
        contactNo: form.value.editUserContact?.toString(),
        firstName: form.value.editFirstName,
        lastName: form.value.editLastName,
        allocatedCoreQuota: allocatedCoreQuotaValue,
        publicKey: form.value.editPublicKey,
        userStartCommand: form.value.editUserCommand,
        userRole: changeUserRole,
        perSessionMaxTime: form.value.perSessionMaxTime,
        sessionWalletBalance:
          !form.value.sessionBalance || form.value.sessionBalance == 0
            ? -1
            : form.value.sessionBalance,
        weeekDaySequence: sequenceString,
        batchStartDate: form.value.batchStartDate,
        batchEndDate: form.value.batchEndDate,
        batchStartTime: form.value.batchStartTime,
        batchEndTime: form.value.batchEndTime,
        userInBatch: this.userInBatch,
        additionalInfo: form.value.editUserAdditionalInfo,
        anywareGuid: form.value.editAnywareUserGuid,
        anywareUpn: form.value.editAnywareUserUpn,
      };
      let updatedUserName = this.data.userName;

      this.userService.editUser(userInfo, updatedUserName).subscribe({
        next: (data: any) => {
          this.snackBar.open(data.message, "Ok", { duration: 5000 });
          // Note: File upload is now handled immediately after selection, not here
          this.userService.reloadUserListOnAction(true);
          if (userInfo.userName != updatedUserName) {
            this.snackBar.open(
              "You will be logged out. Kindly login with new user name.",
              "Ok",
              {
                duration: 10000,
              }
            );
            setTimeout(() => {
              this.authenticationService.logout();
            }, 5000);
          }
        },
        error: (err: any) => {
          this.snackBar.open(
            err.error.message || "Action cannot be completed.",
            "Ok",
            { duration: 5000 }
          );
        },
      });
      if (userInfo.userName == updatedUserName) {
        this.dialog.close(true);
      }
    }
  }
}
